module.exports = __webpack_public_path__ + "img/GM-Logo-weiß.90e5cb67.png";